
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, FormControl, InputLabel, MenuItem, Select, TextField, Avatar, CircularProgress, Paper, Box, Card, CardContent } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import Dropzone from "react-dropzone";

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";

import { table_padding, table_thead } from '../../styles/TableStyle';
import { DropzoneImgStyle, DropzoneThumbInnerStyle, DropzoneThumbsContainerStyle, DropzoneThumbStyle } from "../../styles/Dropzone";

import { ObtenerUnidades } from "../../connections/catalogos/UnidadConnection";
import { ActualizarEstatusTipoServicio, ActualizarTipoServicio, AgregarTipoServicio, TipoServicios } from "../../connections/catalogos/TipoServicioConnection";

import { UnidadProps } from "../../interfaces/catalogos/UnidadInterface";
import { TipoServicioProps } from "../../interfaces/catalogos/TipoServicioInterface";

export const TipoServicioPage = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    
    const [openModal, setOpenModal] = useState( false );

    const [unidad, setUnidad] = useState( 0 );
    const [unidadArray, setUnidadArray] = useState<UnidadProps[]>( [] );

    const [tipoServicios, setTipoServicios] = useState<TipoServicioProps[]>( [] );

    const [idTipoServicio, setIdTipoServicio] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );    
    const [imagen, setImagen] = useState( '' );    
    
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );
    
    const [files, setFiles] = useState<File[]>( [] );

    const handleChangeUnidad = ( newValue: number ) => setUnidad( newValue )

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 5 );

    const thumbs = files.map( ( file, index ) => (
        <div style={ DropzoneThumbStyle } key={ file.name }>
            <div style={ DropzoneThumbInnerStyle } >
                <img
                    alt={ `image-${ index }` }
                    src={ URL.createObjectURL( file ) }
                    style={ DropzoneImgStyle }
                    // Revoke data uri after image is loaded
                    onLoad={() => { URL.revokeObjectURL( URL.createObjectURL( file ) ) }}
                />
            </div>
        </div>
    ));

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const tipoServicioSelected = tipoServicios.find( ( elem ) => elem.idTipoServicio === id );

        if( tipoServicioSelected ){

            await ActualizarEstatusTipoServicio({ idTipoServicio: id, activo: checked }).then( resp => {
                
                const { success, message } = resp;

                if( success ){

                    var newArray = tipoServicios.map( ( elem ) => {

                        if( elem.idTipoServicio === id ){
                            elem.activo = checked;
                        }
            
                        return elem;
                    });
            
                    setTipoServicios( newArray );
                    dispatch( openSnackbar({ message: message, variant: 'success' }));      
                }    
                else{                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));     
                }
    
            });
        }       

    }

    const handleGuardar = async () => {
    
        if( idTipoServicio !== 0 ){

            const tipoServicioSelected = tipoServicios.find( ( elem ) => elem.idTipoServicio === idTipoServicio );

            if( tipoServicioSelected ){

                let formData = new FormData();    
                    
                    formData.append('Descripcion', descripcion);  
                    formData.append('IdUnidad', unidad.toString());  
                    formData.append('IdTipoServicio', idTipoServicio.toString());       

                    if( files.length !== 0 ){
                        formData.append('Imagen', files[0]);  
                    }

                setLoading( true );        
                
                await ActualizarTipoServicio( formData ).then( resp => {
                    
                    const { success, message, idTipoServicio, descripcion, idUnidad, unidad, imagen } = resp;

                    if( success ){

                        setTimeout(() => {
                            
                            var newArray = tipoServicios.map( ( elem ) => {
        
                                if( elem.idTipoServicio === idTipoServicio ){
                                    elem.descripcion = descripcion;          
                                    elem.idUnidad = idUnidad;
                                    elem.unidad = unidad;                                  
                                    elem.imagen = imagen;
                                }
                        
                                return elem;
                            });
                    
                            setTipoServicios( newArray );
                            setOpenModal( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: message, variant: 'success' }));      
                            
                        }, 700);
    
                    }  
                    else{
                        
                        setLoading( false );
                        dispatch( openSnackbar({ message: message, variant: 'error' }));     

                    }  
        
                });
            }           

        }
        else {

            let formData = new FormData();    

                formData.append('Descripcion', descripcion);  
                formData.append('IdUnidad', unidad.toString());  
                
                if( files.length !== 0 ){
                    formData.append('Imagen', files[0]);  
                }

            setLoading( true );

            await AgregarTipoServicio( formData ).then( resp => {

                const { success, message, idTipoServicio, descripcion, idUnidad, unidad, imagen } = resp;
                    
                if( success ){                
            
                    setTimeout(() => {
                        
                        setTipoServicios([ ...tipoServicios, { idTipoServicio, descripcion, idUnidad, unidad, imagen, activo: true, } ]);
                        setOpenModal( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: message, variant: 'success' }));      

                    }, 700);

                }    
                else{
                    setLoading( false );
                    dispatch( openSnackbar({ message: message, variant: 'error' }));      
                }
    
            });

        }
    
    }    

    useEffect(() => {
      
        async function obtener(){

            await ObtenerUnidades().then( resp => {   
                setUnidadArray( resp );
            });

        }

        obtener();

    }, [ ])  
    
    useEffect(() => {
          
        async function obtener(){

            setLoadingData( true );
            setTipoServicios( [] );

            await TipoServicios().then( resp => {

                setTimeout(() => {
                    
                    setTipoServicios( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();
    
    }, [ ])    

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de servicio' } ]} backgroundPaper={ false }>

            <Grid container spacing={3} >  
                
                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    <Button color="secondary" startIcon={ <UndoIcon /> } sx={{ mt: 1 }} onClick={ () => navigate( '/administracion/' ) }> 
                        Regresar
                    </Button> 

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button 
                        variant="contained" 
                        sx={{ mt: 1 }} 
                        onClick={ () => {
                            
                            setIdTipoServicio( 0 );
                            setDescripcion( '' );    
                            setImagen( '' );               
                            setUnidad( 0 );

                            setOpenModal( true );
                        }}
                    > 
                        Agregar
                    </Button> 

                </Grid>

            </Grid>
            
            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...table_thead }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...table_padding, ...table_thead, width:'10%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...table_padding, ...table_thead, width:'25%', textAlign: 'center' }}> Imagen </TableCell>
                            <TableCell style={{ ...table_padding, ...table_thead, width:'25%' }}> Descripción </TableCell>     
                            <TableCell style={{ ...table_padding, ...table_thead, width:'25%' }}> Unidad </TableCell>                                          
                            <TableCell style={{ ...table_padding, ...table_thead, width:'10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ? 
                                    tipoServicios.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                : 
                                    tipoServicios
                            )
                            .map( ( { idTipoServicio, descripcion, imagen, activo, unidad, idUnidad } ) => (

                                <TableRow key={ idTipoServicio} >
                                
                                    <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        { idTipoServicio }
                                    </TableCell>

                                    <TableCell sx={{ justifyItems: 'center', alignItems: 'center' }}>
                                    
                                        <Avatar 
                                            variant="rounded"
                                            sx={{ width: 125, height: 125 }}                                           
                                            src={ 
                                                imagen
                                                ?
                                                    imagen
                                                :
                                                    process.env.PUBLIC_URL + "/assets/sin-imagen.png"
                                            }
                                        />                                  

                                    </TableCell>    

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>      

                                    <TableCell>
                                        { unidad }
                                    </TableCell>                                            
                                                       
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idTipoServicio ) }
                                        />                                            
                       
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {                                                

                                                    setIdTipoServicio( idTipoServicio );
                                                    setImagen( imagen );
                                                    setDescripcion( descripcion );                                          
                                                    setUnidad( idUnidad )

                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  

                                    </TableCell>

                                </TableRow>

                            ))
                        }                    
            
                        { 
                            ( tipoServicios.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 53 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }

                    </TableBody>

                    <TableFooter>

                    {
                            tipoServicios.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> 
                                            Total de registros: { tipoServicios.length } 
                                        </Typography>
                                    </TableCell> 

                                    <TablePagination  
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ tipoServicios.length }                                        
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>
                        }


                    </TableFooter>
                    
                </Table>
                
            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
            
                <DialogContent>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ md: 12, xs: 12 }}>
       
                            <FormControl fullWidth>
                                <InputLabel>Unidad</InputLabel>
                            
                                <Select                                                             
                                    label="Unidad"
                                    value={ unidad }
                                    onChange={ (e) => handleChangeUnidad( parseInt( e.target.value.toString() ) ) }
                                >
                                    <MenuItem key= { 0 } value={ 0 }>Seleccione una opción</MenuItem>
                                    {
                                        unidadArray.map( ( element ) => (
                                            <MenuItem key= { element.idUnidad } value={ element.idUnidad }>{ element.descripcion } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                label={ 'Descripción'}
                                variant="outlined"                           
                                multiline
                                rows={4}                                        
                                fullWidth
                                value={ descripcion }
                                onChange={ (e) => setDescripcion( e.target.value ) }    
                                slotProps={{
                                    input:{
                                        autoComplete:'off'
                                    },
                                    inputLabel: {
                                        shrink: true
                                    }
                                }}
                            />

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <Card>

                                <CardContent>

                                    {
                                        !imagen
                                        ?
                                            <>
                                            
                                                <Dropzone 
                                                    maxFiles={1}
                                                    multiple={ false }
                                                    accept={{ 'image/png': ['.png'], 'image/jpg': ['.jpg'], 'image/jpeg': ['.jpeg'], }}
                                                    onDrop={ ( acceptedFiles: File[] ) =>  setFiles( acceptedFiles ) }
                                                >
                                                    {
                                                        ( { getRootProps, getInputProps }) => (
                                                            <Box
                                                                sx={{
                                                                    border: '3px dashed #999',
                                                                    textAlign: 'center',
                                                                    fontSize: 14, 
                                                                    height: 200,
                                                                }}
                                                                alignContent={'center'}
                                                            >
                                                                <Box { ...getRootProps() }>
                                                                    <input { ...getInputProps() } />
                                                                    <Typography variant="subtitle1" color="#999">Arrastre y suelte aquí la imagen o <br /> haga clic para seleccionarlo</Typography>
                                                                </Box>

                                                            </Box>
                                                            
                                                        )
                                                    }
                                                </Dropzone>

                                                <Box style={ DropzoneThumbsContainerStyle }>
                                                    { thumbs }
                                                </Box>

                                            </>
                                        :
                                            <Box
                                                sx={{
                                                    position: 'relative',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    src={imagen}
                                                    alt="preview"
                                                    sx={{
                                                        width: '100%',
                                                        maxHeight: 300,
                                                        objectFit: 'contain',
                                                        borderRadius: 2,
                                                    }}
                                                />

                                                <Button
                                                    color="secondary"
                                                    sx={{ mt: 2 }}
                                                    onClick={ () => { setFiles( [] ); setImagen( '' ); } }
                                                >
                                                    Eliminar imagen
                                                </Button>

                                            </Box>
                                    }

                                </CardContent>

                            </Card>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button color="secondary" disabled={ loading } onClick={ () => setOpenModal( false ) }> Cancelar </Button>
                    <Button variant='contained' loading={ loading } disabled={ descripcion === '' || unidad === 0  } onClick={ handleGuardar }> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}
